<template>
  <div>
    <SimpleInfoModal
      :visible="faqVisible"
      title="常见问题"
      :lines="faqLines"
      @close="faqVisible = false" />
    <SimpleInfoModal
      :visible="feedbackVisible"
      title="问题反馈"
      :lines="feedbackLines"
      :show-feedback-form="true"
      :submitting="feedbackSubmitting"
      :message="feedbackMessage"
      :is-error="feedbackError"
      @close="closeFeedback"
      @submit="handleFeedbackSubmit" />
    <SimpleInfoModal
      :visible="aboutVisible"
      title="关于我们"
      :lines="aboutLines"
      @close="aboutVisible = false" />
    <MemberMessageHistoryModal
      :visible="messagesVisible"
      @close="messagesVisible = false" />
  </div>
</template>

<script>
import SimpleInfoModal from '@/components/user/SimpleInfoModal.vue'
import MemberMessageHistoryModal from '@/components/user/MemberMessageHistoryModal.vue'
import { submitFeedback } from '@/api/portal/feedback'
import { openLogin } from '@/utils/loginModal'
import { isLoggedIn } from '@/utils/auth'
import {
  onUserFaqOpen,
  offUserFaqOpen,
  onUserFeedbackOpen,
  offUserFeedbackOpen,
  onUserAboutOpen,
  offUserAboutOpen,
  onUserMessagesOpen,
  offUserMessagesOpen
} from '@/utils/userMenu'

export default {
  name: 'UserInfoModals',
  components: { SimpleInfoModal, MemberMessageHistoryModal },
  data() {
    return {
      faqVisible: false,
      feedbackVisible: false,
      aboutVisible: false,
      messagesVisible: false,
      feedbackSubmitting: false,
      feedbackMessage: '',
      feedbackError: false,
      faqLines: [
        '1. 如何登录？点击右上角「登录」，使用微信扫码关注公众号即可完成登录。',
        '2. 点数是什么？点数用于降重、降 AIGC、双降等功能，按字数或次数消耗。',
        '3. 如何充值？登录后点击侧边栏「充值」即可购买点数套餐。',
        '4. 处理失败会扣点吗？任务失败通常不会扣除点数，具体以任务结果为准。',
        '5. 微信头像昵称无法显示？可在微信内打开站点授权同步，或使用默认昵称。'
      ],
      feedbackLines: [
        '请尽量详细描述问题场景、操作步骤与期望结果，我们会尽快处理您的反馈。'
      ],
      aboutLines: [
        '笔芯科研（bixinpaper.com）面向科研与文档场景，提供智能降重、降 AIGC、双降、AIGC 检测等工具。',
        '我们致力于帮助用户在合规前提下提升文本原创度与可读性。',
        'Copyright © 2026 宁夏清和艺坤文化传媒有限公司'
      ]
    }
  },
  mounted() {
    onUserFaqOpen(this.openFaq)
    onUserFeedbackOpen(this.openFeedback)
    onUserAboutOpen(this.openAbout)
    onUserMessagesOpen(this.openMessages)
  },
  beforeDestroy() {
    offUserFaqOpen(this.openFaq)
    offUserFeedbackOpen(this.openFeedback)
    offUserAboutOpen(this.openAbout)
    offUserMessagesOpen(this.openMessages)
  },
  methods: {
    openMessages() {
      if (!isLoggedIn()) {
        openLogin(window.location.pathname + window.location.search)
        return
      }
      this.messagesVisible = true
    },
    openFaq() {
      this.faqVisible = true
    },
    openFeedback() {
      if (!isLoggedIn()) {
        openLogin(window.location.pathname + window.location.search)
        return
      }
      this.feedbackMessage = ''
      this.feedbackError = false
      this.feedbackVisible = true
    },
    openAbout() {
      this.aboutVisible = true
    },
    closeFeedback() {
      this.feedbackVisible = false
      this.feedbackMessage = ''
      this.feedbackError = false
    },
    handleFeedbackSubmit(form) {
      if (!form.content || !form.content.trim()) {
        this.feedbackMessage = '请填写反馈内容'
        this.feedbackError = true
        return
      }
      this.feedbackSubmitting = true
      this.feedbackMessage = ''
      this.feedbackError = false
      submitFeedback({ content: form.content.trim(), contact: (form.contact || '').trim() })
        .then(() => {
          this.feedbackMessage = '提交成功，感谢您的反馈！'
          this.feedbackError = false
          setTimeout(() => {
            this.closeFeedback()
          }, 1200)
        })
        .catch(err => {
          this.feedbackMessage = err.message || '提交失败'
          this.feedbackError = true
        })
        .finally(() => {
          this.feedbackSubmitting = false
        })
    }
  }
}
</script>
